module.exports = __webpack_public_path__ + "static/media/no_upcoming_trips.0962be42.jpg";